/**
 * ehr#859 - run `fn` at most once per `gapMs`, however many times it is asked. The first ask
 * runs at once; asks inside the gap fold into one more run at its end (never more than one
 * waiting), so the last change is never missed. A list that reloads on its own writes, on a
 * version stamp and on a timer then fetches once per burst instead of once per trigger.
 */
export function coalesce(
  fn: () => void,
  gapMs: number,
  clock: {
    now: () => number;
    setTimeout: (cb: () => void, ms: number) => unknown;
  } = { now: () => Date.now(), setTimeout: (cb, ms) => setTimeout(cb, ms) },
): () => void {
  let last = Number.NEGATIVE_INFINITY;
  let waiting = false;
  const run = () => {
    last = clock.now();
    fn();
  };
  return () => {
    if (waiting) return;
    const since = clock.now() - last;
    if (since >= gapMs) return run();
    waiting = true;
    clock.setTimeout(() => {
      waiting = false;
      run();
    }, gapMs - since);
  };
}
